import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const ListaTipo = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="generalCliente" id="miListaETipo" value={permiteUpdate?argsDocum.generalCliente:idLista.generalCliente} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>CLIENTE</option>
        <option>GENERAL</option>
      </select>
    </div>
  )
};

const ListaEstOS = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="estadoAlCrear" id="miListaEOS" value={permiteUpdate?argsDocum.estadoAlCrear:idLista.estadoAlCrear} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>ABIERTA</option>
        <option>CERRADA</option>
      </select>
    </div>
  )
};

const ListaDir = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="permDireccion" id="miLista" value={permiteUpdate?argsDocum.permDireccion:idLista.permDireccion} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>CAMBIAR</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

const ListaTar = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="permTarServ" id="miLista1" value={permiteUpdate?argsDocum.permTarServ:idLista.permTarServ} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>CAMBIAR TARIFA</option>
        <option>IGUAL TARIFA - CAMBIAR SERVICIOS</option>
        <option>IGUAL TARIFA - QUITAR UNO O VARIOS SERVICIOS</option>
        <option>IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

// const ListaOfe = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="permOfertas" id="miLista2" value={permiteUpdate?argsDocum.permOfertas:idLista.permOfertas} onChange={(ev)=>handleChange(ev, argsDocum)}>
//         <option>SI</option>
//         <option>NO</option>
//       </select>
//     </div>
//   )
// };

const ListaEqu = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="permEquipos" id="miLista3" value={permiteUpdate?argsDocum.permEquipos:idLista.permEquipos} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>AGREGAR - RETIRAR</option>
        <option>RETIRAR TODOS</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

const ListaClN = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="paraCliNuevo" id="miLista4" value={permiteUpdate?argsDocum.paraCliNuevo:idLista.paraCliNuevo} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaPA = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="pedirPtosAdic" id="miListaPA" value={permiteUpdate?argsDocum.pedirPtosAdic:idLista.pedirPtosAdic} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaPI = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="permImprimir" id="miListaPI" value={permiteUpdate?argsDocum.permImprimir:idLista.permImprimir} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaECr = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="estadoCrearOS" id="miLista5" value={permiteUpdate?argsDocum.estadoCrearOS:idLista.estadoCrearOS} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>CUALQUIERA</option>
        <option>NUEVO</option>
        <option>ACTIVO</option>
        <option>DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>ACTIVO, DESCONECTADO o SUSPENDIDO</option>
        <option>DESCONECTADO o SUSPENDIDO</option>
        <option>RETIRADO</option>
      </select>
    </div>
  )
};

const ListaECe = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="estadoCerrarOS" id="miLista6" value={permiteUpdate?argsDocum.estadoCerrarOS:idLista.estadoCerrarOS} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>ACTIVO</option>
        <option>DESCONECTADO</option>
        <option>DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

const ListaOSDA = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="genOSDirAnt" id="miListaOSDA" value={permiteUpdate?argsDocum.genOSDirAnt:idLista.genOSDirAnt} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const DetalleNivelTOS = props => {
  return (
    <option>{props.elemento.descrTipoOS}</option>
  )
};

const ListaTOS = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelTOS elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoOSDirAnt" id="miListaTOS" value={permiteUpdate?argsDocum.tipoOSDirAnt:idLista.tipoOSDirAnt} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerTios2 extends React.Component {
  state={
    argsDocum: {codigoTipoOS: this.props.idLista.codigoTipoOS,
                descrTipoOS: this.props.idLista.descrTipoOS,
                estadoAlCrear: this.props.idLista.estadoAlCrear,
                permDireccion: this.props.idLista.permDireccion,
                permTarServ: this.props.idLista.permTarServ,
                permOfertas: this.props.idLista.permOfertas,
                permEquipos: this.props.idLista.permEquipos,
                paraCliNuevo: this.props.idLista.paraCliNuevo,
                pedirPtosAdic: this.props.idLista.pedirPtosAdic,
                permImprimir: this.props.idLista.permImprimir,
                estadoCrearOS: this.props.idLista.estadoCrearOS,
                estadoCerrarOS: this.props.idLista.estadoCerrarOS,
                generalCliente: this.props.idLista.generalCliente,
                genOSDirAnt: this.props.idLista.genOSDirAnt,
                tipoOSDirAnt: !this.props.idLista.tipoOSDirAnt?"":this.props.idLista.tipoOSDirAnt,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "codigoTipoOS" && ev.target.name !== "descrTipoOS"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "estadoAlCrear"){
          let miLista = document.getElementById("miListaEOS");
          argsDocum['estadoAlCrear'] = miLista.options[miLista.selectedIndex].text
        }else{
          if(ev.target.name === "permDireccion"){
            let miLista = document.getElementById("miLista");
            argsDocum['permDireccion'] = miLista.options[miLista.selectedIndex].text
          }else{
            if(ev.target.name === "permTarServ"){
              let miLista = document.getElementById("miLista1");
              argsDocum['permTarServ'] = miLista.options[miLista.selectedIndex].text
            }else{
              if(ev.target.name === "permOfertas"){
                let miLista = document.getElementById("miLista2");
                argsDocum['permOfertas'] = miLista.options[miLista.selectedIndex].text
              }else{
                if(ev.target.name === "permEquipos"){
                  let miLista = document.getElementById("miLista3");
                  argsDocum['permEquipos'] = miLista.options[miLista.selectedIndex].text
                }else{
                  if(ev.target.name === "paraCliNuevo"){
                    let miLista = document.getElementById("miLista4");
                    argsDocum['paraCliNuevo'] = miLista.options[miLista.selectedIndex].text
                  }else{
                    if(ev.target.name === "estadoCrearOS"){
                      let miLista = document.getElementById("miLista5");
                      argsDocum['estadoCrearOS'] = miLista.options[miLista.selectedIndex].text
                    }else{
                      if(ev.target.name === "estadoCerrarOS"){
                        let miLista = document.getElementById("miLista6");
                        argsDocum['estadoCerrarOS'] = miLista.options[miLista.selectedIndex].text
                      }else{
                        if(ev.target.name === "pedirPtosAdic"){
                          let miLista = document.getElementById("miListaPA");
                          argsDocum['pedirPtosAdic'] = miLista.options[miLista.selectedIndex].text
                        }else{
                          if(ev.target.name === "permImprimir"){
                            let miLista = document.getElementById("miListaPI");
                            argsDocum['permImprimir'] = miLista.options[miLista.selectedIndex].text
                          }else{
                            if(ev.target.name === "generalCliente"){
                              let miLista = document.getElementById("miListaETipo");
                              argsDocum['generalCliente'] = miLista.options[miLista.selectedIndex].text
                            }else{
                              if(ev.target.name === "genOSDirAnt"){
                                let miLista = document.getElementById("miListaOSDA");
                                argsDocum['genOSDirAnt'] = miLista.options[miLista.selectedIndex].text

                                if(miLista.options[miLista.selectedIndex].text==="NO"||miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
                                  argsDocum['tipoOSDirAnt'] = "Seleccionar..."
                                  // let miListaTOS = document.getElementById("miListaTOS");
                                  // miListaTOS.options.selectedIndex = 0
                                }
                            
                              }else{
                                if(ev.target.name === "tipoOSDirAnt"){
                                  let miLista = document.getElementById("miListaTOS");
                                  argsDocum['tipoOSDirAnt'] = miLista.options[miLista.selectedIndex].text
                                }else{
                                  argsDocum[ev.target.name] = ev.target.value
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;

// console.log(this.props.idLista)
// console.log(argsDocum)
    let listTOS = this.props.list
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large hand point down yellow icon"></i>
            Tipo O de S
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigoTipoOS" id="codigoTipoOS" value={argsDocum.codigoTipoOS} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoTipoOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrTipoOS" id="descrTipoOS" value={this.props.permiteUpdate?argsDocum.descrTipoOS:this.props.idLista.descrTipoOS} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrTipoOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>OS de tipo GENERAL / CLIENTE:</label>
                    <ListaTipo styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Al crear la OS debe quedar en estado:</label>
                    <ListaEstOS styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Dirección ={">"} permitir:</label>
                    <ListaDir styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tarifas / Servicios ={">"} permitir:</label>
                    <ListaTar styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  {/* <Form.Field>
                    <label style={this.props.styles.label}>Ofertas ={">"} permitir actualizar:</label>
                    <ListaOfe styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field> */}
                  <Form.Field>
                    <label style={this.props.styles.label}>Equipos ={">"} permitir:</label>
                    <ListaEqu styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Seleccionar para clientes nuevos:</label>
                    <ListaClN styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Pedir Ptos Adic:</label>
                          <ListaPA styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Permitir imprimir las OS:</label>
                          <ListaPI styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </div>
                      </div>
                    </div>
                  </Form.Field>

                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Estado del cliente al crear OS:</label>
                          <ListaECr styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Estado del cliente al cerrar OS:</label>
                          <ListaECe styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </div>
                      </div>
                    </div>
                  </Form.Field>

                  <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={this.props.styles.label}>Si cambia de dirección generar OS a dirección anterior:</label>
                        <ListaOSDA styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </div>
                      {argsDocum.genOSDirAnt==="SI" &&
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Tipo de OS a generar:</label>
                          <ListaTOS list={listTOS} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </div>
                      }
                    </div>
                  </div>
                </Form.Field>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerTios2
